import { render, staticRenderFns } from "./Restaurants.vue?vue&type=template&id=802ea3c0"
import script from "./Restaurants.vue?vue&type=script&lang=ts"
export * from "./Restaurants.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports